export const DATETIME_LOCAL_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
